<template>
  <div>
    <CCol sm="12" lg="12" class="mt-3">
      <CContainer>
        <CCol sm="12" color="light">
          <h1 style="color: #000" class="mt-3 text-dark">
            {{ profiles.Name }}
          </h1>
        </CCol>
      </CContainer>
      <div class="bg-white">
        <CContainer>
          <CRow>
            <CCol sm="3" lg="3">
              <div>
                   <img  
                     v-if="profiles.PicturePath == ''"
                    width="200"
                  height="200"
                    src="../assets/img/default.png">
                <img v-else
                  width="200"
                  height="200"
                   :src="getPic(profiles)"
                  class="attachment-thumb_526x526 size-thumb_526x526 wp-post-image mt-4"
                  alt=""
                  sizes="(max-width: 360px) 100vw, 360px"
                />
                <h6 class="text-dark mt-3">{{ profiles.Email }}</h6>
                <h6
                  v-for="race in profiles.RaceList"
                  v-bind:key="race.Id"
                  class="text-dark"
                >
                  {{ race.Name }}
                </h6>
                <hr />
                <h4 class="text-dark">Area Of Expertise</h4>

                <ul
                  class="text-dark"
                  v-for="area in profiles.AreaOfExpertiseList"
                  v-bind:key="area.Id"
                >
                  <li>{{ area.Name }}</li>
                </ul>
              </div>
            </CCol>
            <CCol sm="9" lg="9">
              <CRow>
                <CCol sm="9" lg="9">
                  <div class="mt-5">
                    <span
                      v-for="subject in profiles.TeachingSubjectList"
                      v-bind:key="subject.Id"
                    >
                      <CButton
                        color="outline-success"
                        class="text-center m-1"
                        >{{ subject.Name }}</CButton
                      >
                    </span>
                  </div>
                </CCol>
                <CCol sm="3" lg="3">
                  <br /><br />
                  <CButton
                    style="background: #1565d8"
                    block
                    color="primary"
                    size="lg"
                    >BOOK NOW</CButton
                  >
                </CCol>
              </CRow>
              <hr />
              <h4 class="text-dark">Professional Profile</h4>
              <p
                class="text-dark"
                v-for="pro in profiles.ProfessionalProfileList"
                v-bind:key="pro.Id"
              >
                <i>{{ pro.Name }} </i>
              </p>
              <hr />
              <h4 class="text-dark">Work Background</h4>

              <ul
                class="text-dark"
                v-for="work in profiles.WorkBackgroundList"
                v-bind:key="work.Id"
              >
                <li>{{ work.Name }}</li>
              </ul>
              <hr />
              <h4 class="text-dark">Academic Profile</h4>

              <ul
                class="text-dark"
                v-for="acad in profiles.AcademicProfileList"
                v-bind:key="acad.Id"
              >
                <li>{{ acad.Name }}</li>
              </ul>
            </CCol>
            <!-- <CCol sm="12" lg="12">
              <h3 class="text-dark mt-5">Subject Schedule</h3>
              <table class="table table-responsive-sm outline mt-2">
                <thead>
                  <th>#</th>
                  <th>Subject</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Physic</td>
                    <td>24/10/2020 13:20 PM</td>
                    <td>24/10/2020 14:20 PM</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Chemistry</td>
                    <td>24/10/2020 13:20 PM</td>
                    <td>24/10/2020 14:20 PM</td>
                  </tr>
                </tbody>
              </table>
            </CCol> -->
          </CRow>
        </CContainer>
      </div>
    </CCol>
  </div>
</template>     
<script>
import backgroundUrl from "../assets/img/bgBuilding.png";
import backgroundUrlTemplate from "../assets/img/bg.png";
export default {
  name: "Login",
  data() {
    return {
      backgroundUrl,
      backgroundUrlTemplate,
      profiles: {
        race: [],
      },
    };
  },
  async mounted() {
    await this.GetProfile();
  },
  methods: {
      getPic(profiles) {
      return "https://pickiddo.com/" + profiles.PicturePath;
    },
    async GetProfile() {
      this.$API
        .get(this.$ProfileTeacher + "?userid=" + this.$route.query.userid, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.profiles = response.data;
          }
        });
    },
  },
};
</script>


